import { render, staticRenderFns } from "./DescargoArchivoPage.vue?vue&type=template&id=41f73ade"
import script from "./DescargoArchivoPage.js?vue&type=script&lang=js&external"
export * from "./DescargoArchivoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports